// Use API_URL env and include credentials for secure cookie
const API_URL = process.env.REACT_APP_API_URL;
const fetchConfig = {
  credentials: "include",
  headers: { Accept: "application/json" },
};

const getNewUsersChartData = async (range, interval) => {
  const response = await fetch(
    `${API_URL}/analytics/new_users/${interval}/${range}`,
    { ...fetchConfig, method: "GET" }
  );
  return response.json();
};

const getNewTasksChartData = async (range, interval) => {
  const response = await fetch(
    `${API_URL}/analytics/new_tasks/${interval}/${range}`,
    { ...fetchConfig, method: "GET" }
  );
  return response.json();
};

export { getNewUsersChartData, getNewTasksChartData };
